import React, { useEffect, useState,useRef } from "react";
import { Box, Typography, Paper, CircularProgress, Container } from "@mui/material";
import StudentLayout from "../../components/student/StudentLayout";
import ReactPlayer from "react-player";

const getYoutubeVideoId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|\/u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};
function CustomYouTubePlayer({ videoId }) {
    const playerRef = useRef(null);
  
    useEffect(() => {
        const loadPlayer = () => {
          if (window.YT && window.YT.Player) {
            playerRef.current = new window.YT.Player("yt-player", {
              videoId,
              events: {
                onReady: (event) => {
                  event.target.playVideo();
                },
                onStateChange: (event) => {
                  if (event.data === window.YT.PlayerState.ENDED) {
                    console.log("الفيديو انتهى");
                  }
                }
              },
              playerVars: {
                autoplay: 0,
                // controls: 0,
                modestbranding: 1,
                rel: 0,
                fs: 0,
                disablekb: 1,
                iv_load_policy: 3,
                playsinline: 1
              }
              
            });
          } else {
            // Retry if API isn't ready yet
            setTimeout(loadPlayer, 100);
          }
        };
      
        loadPlayer();
      }, [videoId]);
      
    return <div id="yt-player" style={{ width: "100%", height: "600px" }} />;
  }
  
function StudentViewLecture() {
  const [loading, setLoading] = useState(true);
  const [videoUrl, setVideoUrl] = useState("");
  const [lectureName, setLectureName] = useState("");

  useEffect(() => {
    // جلب الفيديو من localStorage (يفترض أنه تم تخزينه مسبقًا)
    const storedVideoUrl = localStorage.getItem("lectureVideo");
    const storedLectureName = localStorage.getItem("lectureNameAR");
 console.log(storedVideoUrl);
 
    if (storedVideoUrl) {
      setVideoUrl(storedVideoUrl);
    }
    if (storedLectureName) {
      setLectureName(storedLectureName);
    }

    setLoading(false);
  }, []);

  const videoId = getYoutubeVideoId(videoUrl);

  if (loading) {
    return (
      <StudentLayout>
             <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box> 
      </StudentLayout>

    );
  }

  if (!videoId) {
    return (
        <StudentLayout>
               <Box textAlign="center" mt={5}>
        <Typography color="error">رابط الفيديو غير صالح</Typography>
      </Box>   
        </StudentLayout>

    );
  }

  return (
    <StudentLayout>
    <div className="container">
      <div className="row">
        <div className="text-warning mb-3 mt-1 fs-3 fw-bold border shadow text-center p-2">{lectureName}</div>
      </div>
      <div>
      <CustomYouTubePlayer videoId={videoId} />
      </div>
    </div>
    </StudentLayout>

  );
}

export default StudentViewLecture;

